import React, { Component } from "react";
import { gql } from "@apollo/client";
import { apolloClient } from "../../../index";
import "./DocumentAbstractViewMode.scss";
import TabContent from "../../DocumentTemplate/NewTemplate/ViewMode/TabContent/TabContent";
import DocumentComments from "../DocumentComments/DocumentComments";
import { notify } from "../../Notify/Notify";
import PersonalNotes from "../PersonalNotes/PersonalNotes";

class DocumentAbstractViewMode extends Component {
  state = {
    activeTab: "",
    comments: [],
    overview: "",
    notes: [],
    isLoading: false,
  };

  activeTab = "";

  componentDidMount() {
                
    this.loadComments();
    this.loadNotes();

    this.setState({
      activeTab: this.props.isCommentActive ? "comment" : "",
    });
  }

  componentDidUpdate(prevProps) {
    if(this.props.isSubFileSelected === !prevProps.isSubFileSelected) {
      if(this.props.isSubFileSelected) {
        this.setOverviewTab()
      } else {
        this.setActiveTab()
      }
    }
  }

  setOverviewTab() {
    this.setState({
      activeTab: "overview",
    });
  }

  setActiveTab() {
    
    let activeTab = this.props.parsedAbstract
        .filter((tab) => tab.tabTitle !== "Overview")

    if(activeTab && activeTab.length > 0) {
      activeTab = activeTab[0].tabTitle.toLowerCase().replace(" ", "-");
      this.setState({
          activeTab: activeTab,
      });
    }

  }
  
  loadComments = () => {
    this.setState({ isLoading: true });
    const variables = {
      documentId: this.props.documentObj.id,
    };

    apolloClient
      .query({
        query: gql`
          query notesOfDocument($documentId: UUID!) {
            notesOfDocument(documentId: $documentId) {
              id
              note
              commentReaction {
                id
                emojiId
                emoji
                reactedBy {
                  id
                  firstName
                  lastName
                }
              }
              parentComment {
                id
              }
              noteAttachment {
                id
                name
                size
                attachmentFileUrl
              }
              createdTs
              createdBy {
                id
                firstName
                lastName
                email
                profile {
                  image
                  role {
                    id
                    name
                  }
                }
              }
              documentnoteSet {
                id
                note
                commentReaction {
                  id
                  emojiId
                  emoji
                  reactedBy {
                    id
                    firstName
                    lastName
                  }
                }
                parentComment {
                  id
                }
                noteAttachment {
                  id
                  name
                  size
                  attachmentFileUrl
                }
                createdTs
                createdBy {
                  id
                  firstName
                  lastName
                  email
                  profile {
                    image
                    role {
                      id
                      name
                    }
                  }
                }
                documentnoteSet {
                  id
                }
              }
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        this.setState({
          comments: result.data.notesOfDocument,
          isLoading: false,
        });
      })
      .catch((e) => {
        this.setState({ isLoading: false });
        const title = "Error";
        const detail = e.message;
        const type = "error";
        notify(title, detail, type);
      });
  };

  loadNotes = () => {
    const variables = {
      documentId: this.props.documentObj.id,
    };

    apolloClient
      .query({
        query: gql`
          query personalNotesOfDocument($documentId: UUID!) {
            personalNotesOfDocument(documentId: $documentId) {
              id
              note
              noteAttachment {
                id
                name
                size
                attachmentFileUrl
              }
              createdTs
              createdBy {
                id
                firstName
                lastName
                email
                profile {
                  image
                  role {
                    id
                    name
                  }
                }
              }
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        this.setState({ notes: result.data.personalNotesOfDocument });
      })
      .catch((e) => {
        this.setState({ isLoading: false });
        const title = "Error";
        const detail = e.message;
        const type = "error";
        notify(title, detail, type);
      });
  };
  getHeader = () => {
    const handleTabChange = (tab) => {
      this.setState({ activeTab: tab });
    };
    let tabs = [
      ...this.props.parsedAbstract,
      {
        tabTitle: "Comment",
      },
      {
        tabTitle: "Notes",
      },
    ];
      
    const overiewTabIndex = tabs.findIndex((tab) => tab.tabTitle === 'Overview');

    if(overiewTabIndex !== -1) {
      const overviewTab = [...tabs][overiewTabIndex];
      tabs = [
        ...tabs.filter((tab) => tab.tabTitle !== 'Overview'),
        overviewTab
      ]
    }

    const tabsComponents =  tabs.map((item, index) => (
      <div
        key={index}
        onClick={() =>
          handleTabChange(item.tabTitle.toLowerCase().replace(" ", "-"))
        }
        className={`view-mode-nav-item bold ${
          item.tabTitle.toLowerCase().replace(" ", "-") === this.state.activeTab
            ? "active"
            : ""
        }`}
      >
        {item.tabTitle}
      </div>
    ));

    return  (
      <div className="view-mode-header d-flex align-items-center">
        {tabsComponents}
      </div>
    )
  };

  render() {
    if (!this.state.activeTab && this.props.parsedAbstract.length > 0) {
      if (
        (this.props.uploadedFile || !this.props.viewOnly) &&
        !this.state.dataSaved
      ) {
        this.setOverviewTab()
      } else {
        this.setActiveTab()
      }
    }

    let tempAbstract = null;
    if (
      this.state.activeTab !== "comment" &&
      this.state.activeTab !== "notes"
    ) {
      const tabContent = this.props.parsedAbstract.find(
        ({ tabTitle }) =>
          tabTitle.toLowerCase().replace(" ", "-") === this.state.activeTab
      );
      if (tabContent && "tabSections" in tabContent) {
        tempAbstract = (
          <div className="ml-7 document-abstract-section pb-6">
            <TabContent
              tabName={this.state.activeTab}
              sections={tabContent.tabSections}
              showInDocUpload={true}
              viewOnly={this.props.viewOnly}
              dropdownValueChangeHandler={this.props.dropdownValueChangeHandler}
              fieldValueChangeHandler={this.props.fieldValueChangeHandler}
              radioValueChangeHandler={this.props.radioValueChangeHandler}
              checkboxValueChangeHandler={this.props.checkboxValueChangeHandler}
              documentViewMode={true}
              addFieldToSection={this.props.addFieldToSection}
              editFieldInSection={this.props.editFieldInSection}
              deleteFieldFromSection={this.props.deleteFieldFromSection}
              userRole={this.props.userRole}
              handleAddNewTag={this.props.handleAddNewTag}
            />
          </div>
        );
      }
    } else {
      if (this.state.activeTab === "comment") {
        tempAbstract = (
          <DocumentComments
            documentObj={this.props.documentObj}
            comments={this.state.comments}
            loadComments={this.loadComments}
            showLoader={this.state.isLoading}
            archiveView={this.props.archiveView}
          />
        );
      } else {
        tempAbstract = (
          <PersonalNotes
            documentObj={this.props.documentObj}
            comments={this.state.notes}
            loadNotes={this.loadNotes}
            showLoader={this.state.isLoading}
            archiveView={this.props.archiveView}
          />
        );
      }
    }
    return (
      <div className="document-abstract-view-mode-container">
        
        {!this.props.isSubFileSelected ? this.getHeader() : null}

        {tempAbstract}
      </div>
    );
  }
}

export default DocumentAbstractViewMode;
